"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericSliderRenderer = exports.NumericSliderControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const InputNumber_1 = require("../antd/InputNumber");
const Slider_1 = require("../antd/Slider");
const react_1 = require("@jsonforms/react");
const NumericSliderControl = (props) => {
    if (!props.visible)
        return null;
    const initialValue = typeof props.schema.default === "number"
        ? props.schema.default
        : props.schema.minimum;
    const rules = [
        { required: props.required, message: `${props.label} is required` },
    ];
    const formItemProps = "formItemProps" in props.uischema ? props.uischema.formItemProps : {};
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: props.label, id: props.id, name: props.path, required: props.required, initialValue: initialValue, rules: rules, validateTrigger: ["onBlur"], ...formItemProps, children: (0, jsx_runtime_1.jsxs)(antd_1.Row, { children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { span: 8, children: (0, Slider_1.Slider)({ ...props }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { span: 7, children: (0, InputNumber_1.InputNumber)({ ...props }) })] }) }));
};
exports.NumericSliderControl = NumericSliderControl;
exports.NumericSliderRenderer = (0, react_1.withJsonFormsControlProps)(exports.NumericSliderControl);
